import { Controller } from 'stimulus';
import consumer from '../channels/consumer';

export default class extends Controller {

  connect() {
    this.subscrption = consumer.subscriptions.create({
      channel: "VoucherChannel",
    }, {
      received: () => {
        this.load()
      }
    });
  }

  disconnect() {
    this.subscription.unsubscribe();
  }

  load() {
    try {
      Rails.ajax({
        url: "vouchers.js",
        type: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        dataType: 'json',
        success: () => { }
      })
    } catch (error) {
      console.log(error)
    }
  }
}
